import { render, staticRenderFns } from "./LargeScreen.vue?vue&type=template&id=206215cb"
import script from "./LargeScreen.vue?vue&type=script&lang=js"
export * from "./LargeScreen.vue?vue&type=script&lang=js"
import style0 from "./LargeScreen.vue?vue&type=style&index=0&id=206215cb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports